// Turbo snapshots the page when navigating away. A Bootstrap 3 modal that is open at that
// moment is cached open, and on Back the restored copy has lost its modal instance, so its
// Cancel and X buttons do nothing. Close any open modal (and its backdrop) before caching.
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll(".modal.in").forEach(modal => {
    modal.classList.remove("in")
    modal.style.display = "none"
    modal.setAttribute("aria-hidden", "true")
  })
  document.querySelectorAll(".modal-backdrop").forEach(backdrop => backdrop.remove())
  document.body.classList.remove("modal-open")
  document.body.style.paddingRight = ""
})
